export default __webpack_public_path__ + "static/media/2.7608524d.jpg";